// src/components/LegalNotice.tsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LegalNotice: React.FC = () => {
  // legal + common 네임스페이스 동시 사용
  const { t } = useTranslation(["legal", "common"]);

  return (
    <footer className="legal-footer" role="contentinfo" aria-label="Legal notice">
      <div className="inner">
        {/* 법적 고지 */}
        <p className="txt">
          {t(
            "legal:disclaimer",
            "This service provides market data and chart tools for educational purposes only. It is not investment advice, brokerage, or a guarantee of profits. All responsibility lies with the user. Advertisements may be shown, and the service is free to use."
          )}
        </p>

        {/* 내부 이동: SPA 라우팅 (새창 X) */}
        <div className="links">
          <Link to="/terms">{t("common:nav.terms", "Terms of Service")}</Link>
          <span> · </span>
          <Link to="/privacy">{t("common:nav.privacy", "Privacy Policy")}</Link>
        </div>

        {/* 브랜드 표기 */}
        <p className="brand">© Created by ZUZUSIGNAL</p>
      </div>

      <style>{`
        .legal-footer {
          background:#0f1420;
          border-top:1px solid #2a3344;
          margin-top:24px;
          padding:16px 0;
        }
        .legal-footer .inner {
          max-width:960px;
          margin:0 auto;
          padding:0 14px;
          text-align:center;
          color:#9fb1c3;
        }
        .legal-footer .txt {
          font-size:12px;
          line-height:1.6;
          margin:0 0 8px;
          white-space:pre-line;
        }
        .legal-footer .links {
          font-size:13px;
          margin-bottom:6px;
        }
        .legal-footer .links a {
          color:#60a5fa;
          text-decoration:none;
        }
        .legal-footer .links a:hover {
          text-decoration:underline;
        }
        .legal-footer .brand {
          font-size:12px;
          margin:0;
          color:#64748b;
        }
      `}</style>
    </footer>
  );
};

export default LegalNotice;
